// Updated OrderRow.tsx (with fixed useEffect and minor improvements for code quality)
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import FoodItemRow from "./FoodItemRow.tsx";
import * as React from "react";
import RefundedRow from "./RefundedRow.tsx";
import WithdrawRow from "./WithdrawRow.tsx";
import TransactionRow from "./TransactionRow.tsx";
import { useEffect } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import {
  Dialog,
  Grid,
  DialogTitle,
  DialogActions,
  DialogContent,
  TextField,
  FormControl,
  InputLabel,
  Select,
  Autocomplete,
  TableContainer,
  Checkbox,
  Paper,
} from "@mui/material";
import closeIcon from "../../assets/icons/close-white.png";
import itemImg from "./../../assets/icons/Item.png";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import jwt_decode from "jwt-decode";
import "./OrderRow.css";
import LoadingView from "../components/LoadingView/LoadingView.js";
import FullRefundModal from "./Component/ReFund/FullRefundModal.js";
import PartialRefundModal from "./Component/ReFund/PartialRefundModal.js";
import MatchRefundModal from "./Component/ReFund/MatchRefundModal.js";
// Import the new utils
import {
  getRefundTotalForItem,
  calculateTotalRefundAmount,
  getAddonTotalPrice,
  getRefundableAddonAmounts,
  getRefundableItemPrices,
} from "./refundCalculations.js"; // Adjust path as needed

const OrderRow = (props: {
  row: any;
  transactions: any;
  TotalData: any;
  SetRefreshData: any;
  RefreshData: any;
}) => {
  const apiAddress = process.env.REACT_APP_SECRET;
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const [openRefundPopup, setOpenRefundPopup] = React.useState(false);
  const [openPartialRefundModal, setOpenPartialRefundModal] =
    React.useState(false);
  const [openWithdrawRefundModal, setOpenWithdrawRefundModal] =
    React.useState(false);
  const [selectedRowToRefund, setSelectedRowToRefund] = React.useState({});
  const [refundReason, setRefundReason] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openMenu = Boolean(anchorEl);
  const [selectedPartialRefundItems, setSelectedPartialRefundItems] =
    React.useState([]);
  const [selectedTransactionToRefundFrom, setSelectedTransactionToRefundFrom] =
    React.useState([]);
  const [showRefundFromOtherOrder, setShowRefundFromOtherOrder] =
    React.useState(false);
  const [
    checkForRequiredAmountToWithdraw,
    setCheckForRequiredAmountToWithdraw,
  ] = React.useState("");
  const [withdrawPartialRefundOnAction, setWithdrawPartialRefundOnAction] =
    React.useState(false);
  const [calculatedTotalFoodItemPrice, setCalculatedTotalFoodItemPrice] =
    React.useState(0.0);
  const [bankDetailsList, setBankDetailsList] = React.useState([]);
  const [selectedRestaurant, setSelectedRestaurant] = React.useState({});
  const [selectedBank, setSelectedBank] = React.useState(null);
  const [hasRemainingAmount, setHasRemainingAmount] = React.useState(false);
  const [RefundValidationError, setRefundValidationError] =
    React.useState(false);
  const [
    emailAddressToSendRefundPaymentForm,
    setEmailAddressToSendRefundPaymentForm,
  ] = React.useState("");
  const [emailValidationError, setEmailValidationError] = React.useState(false);
  const [selectedRefundProcessingType, setSelectedRefundProcessingType] =
    React.useState(null);
  const [
    refundProcessingTypeValidationError,
    setRefundProcessingTypeValidationError,
  ] = React.useState(false);
  const userToken = localStorage.getItem("gotasteadmintoken");
  const restaurantToken = localStorage.getItem("parentrestaurant");
  const [addOnToRefund, setAddOnToRefund] = React.useState([]);
  const [alteredQuantity, setAlteredQuantity] = React.useState([]);
  const [allowWithdrawRefund, setAllowWithdrawRefund] = React.useState(false);
  const [alreadyUsedTransactionToRefund, setAlreadyUsedTransactionToRefund] =
    React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [alreadyPartialRefunded, setAlreadyPartialRefunded] =
    React.useState(false);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const FullRefundOnClick = (data) => {
    setOpenRefundPopup(true);
    setSelectedRowToRefund(data);
    handleClose();
  };

  const PartialRefundOnClick = (data) => {
    setOpenPartialRefundModal(true);
    setSelectedRowToRefund(data);
    handleClose();
  };

  const WithdrawRefundOnClick = (data) => {
    setOpenWithdrawRefundModal(true);
    setSelectedRowToRefund(data);
    handleClose();
  };

  const WithdrawPartialRefundOnClick = (data) => {
    setWithdrawPartialRefundOnAction(true);
    setOpenWithdrawRefundModal(true);
    setSelectedRowToRefund(data);
    handleClose();
  };

  const handleCloseRefundModals = () => {
    setOpenRefundPopup(false);
    setOpenPartialRefundModal(false);
    setOpenWithdrawRefundModal(false);
    setRefundReason("");
    setSelectedPartialRefundItems([]);
    setAllowWithdrawRefund(false);
    setSelectedTransactionToRefundFrom([]);
    setHasRemainingAmount(false);
    setSelectedBank(null);
    setSelectedRestaurant(null);
    setWithdrawPartialRefundOnAction(false);
    setRefundValidationError(false);
    setCheckForRequiredAmountToWithdraw("");
    setSelectedRefundProcessingType(null);
    setEmailAddressToSendRefundPaymentForm("");
    setEmailValidationError(false);
    setRefundProcessingTypeValidationError(false);
    setSelectedRowToRefund({});
    setAlteredQuantity([]);
    setAddOnToRefund([]);
  };

  // Validation effect
  useEffect(() => {
    if (refundReason !== "") {
      setRefundValidationError(false);
      return;
    }
    if (selectedPartialRefundItems?.length !== 0) {
      setRefundValidationError(false);
      return;
    }
    if (selectedRestaurant !== null) {
      setRefundValidationError(false);
      return;
    }
    if (selectedTransactionToRefundFrom?.length === 0) {
      setRefundValidationError(false);
      setCheckForRequiredAmountToWithdraw("");
      setHasRemainingAmount(false);
      return;
    }
  }, [
    refundReason,
    selectedPartialRefundItems,
    selectedRestaurant,
    selectedBank,
    selectedTransactionToRefundFrom,
  ]);

  // Email validation effect
  useEffect(() => {
    if (emailAddressToSendRefundPaymentForm !== "") {
      setEmailValidationError(false);
    }
  }, [emailAddressToSendRefundPaymentForm]);

  useEffect(() => {
    if (!openRefundPopup) {
      setEmailAddressToSendRefundPaymentForm("");
      setEmailValidationError(false);
    }
  }, [openRefundPopup]);

  useEffect(() => {
    if (selectedRefundProcessingType !== null) {
      setRefundProcessingTypeValidationError(false);
    }
  }, [selectedRefundProcessingType]);

  const checkForValidation = () => {
    if (refundReason === "") {
      setRefundValidationError(true);
      return false;
    }
    if (selectedRefundProcessingType === null) {
      setRefundProcessingTypeValidationError(true);
      return false;
    }
    const isValidEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };
    if (
      selectedRefundProcessingType?.label === "Bank" &&
      (!emailAddressToSendRefundPaymentForm ||
        !isValidEmail(emailAddressToSendRefundPaymentForm))
    ) {
      setEmailValidationError(true);
      return false;
    }
    return true;
  };

  // Updated CalculateTotalRefundAmountManually using utils
  const CalculateTotalRefundAmountManually = (orderData) => {
    if (!orderData || !orderData.items) return "0.00";
    return calculateTotalRefundAmount(
      orderData.items,
      orderData,
      (item) => item.qty, // remaining qty
      (item) =>
        item.addons?.filter((ad) => ad.refundStatus !== "Refunded") || [],
    );
  };

  // Refund Request (full)
  const RefundRequest = async () => {
    if (!checkForValidation()) return;
    if (!userToken) {
      toast.error("No User Found!");
      return;
    }
    const userTokenDec = jwt_decode(userToken);
    const loginUserId = userTokenDec?.UserId;
    console.log("asasx", selectedRowToRefund);

    const orderItemsWithPrices =
      selectedRowToRefund?.items
        ?.filter((item) => item.qty !== 0)
        .map((item) => {
          const refundQty = item.qty;
          const selectedAddons =
            item.addons?.filter((ad) => ad.refundStatus !== "Refunded") || [];
          const { itemTips, itemSC, itemSCVat } = getRefundableItemPrices(
            item,
            refundQty,
            selectedRowToRefund,
          );
          const addonPayloads = (item.addons || [])
            .filter((ad) => ad.refundStatus !== "Refunded")
            .map((addon) => {
              const addonFullPrice = getAddonTotalPrice(addon);
              // const { addonTips, addonSC, addonSCVat } =
              //   getRefundableAddonAmounts(addonFullPrice, selectedRowToRefund);
              const addonTips = addon.remainingTips;
              const addonSC = addon.remainingServiceCharge;
              const addonSCVat = addon.remainingServiceChargeVAT;
              return {
                addOnId: addon.id,
                addOnPrice: addon.totalPrice,
                AddOnTipsAmount: addonTips.toFixed(5),
                AddOnServiceChargeAmount: addonSC.toFixed(5),
                AddOnServiceChargeVatAmount: addonSCVat.toFixed(5),
                addOnQuantity: parseInt(addon?.qty || 1),
                options: addon?.options?.length
                  ? addon.options.map((option) => ({
                      optionId: option.optionId,
                      optionPrice: option.totalPrice,
                      optionQty: parseInt(option.qty || 1),
                      subOptions: option?.subOptions?.length
                        ? option.subOptions.map((subOption) => ({
                            subOptionId: subOption.subOptionId,
                            subOptionPrice: subOption.totalPrice,
                            subOptionQty: parseInt(
                              subOption?.subOptionQuantity ?? 1,
                            ),
                          }))
                        : null,
                    }))
                  : null,
              };
            });
          return {
            orderItemId: item.orderItemId,
            totalPrice: (
              (item.basePrice + item.sdInAmount + item.vatInAmount) *
              refundQty
            ).toFixed(2),
            TipsAmount: itemTips,
            ServiceChargeAmount: itemSC,
            ServiceChargeVatAmount: itemSCVat,
            quantity: refundQty,
            addOns: addonPayloads?.length ? addonPayloads : null,
          };
        }) || [];

    const total = calculateTotalRefundAmount(
      selectedRowToRefund.items,
      selectedRowToRefund,
      (item) => item.qty, // Full qty for full refund
      (item) =>
        item.addons?.filter((ad) => ad.refundStatus !== "Refunded") || [], // All non-refunded addons
    );

    const payload = {
      orderPaymentId: selectedRowToRefund.orderPaymentId,
      orderStatus: "Transaction/FullRefund",
      refundTypeId: "1",
      refundFromOrderId: "",
      refundAmount: alreadyPartialRefunded
        ? CalculateTotalRefundAmountManually(selectedRowToRefund)
        : total,
      refundReasonDescription: refundReason,
      creatorId: loginUserId,
      refundItems: orderItemsWithPrices,
      processingType: selectedRefundProcessingType?.label, //Bank OR Card
      emailAddress: "demoEmail",
      refundStatus: "RS002",
    };
    try {
      setLoading(true);
      const response = await axios.post(
        `${apiAddress}/api/OrderRefund/OrderRefund`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );
      setLoading(false);
      if (
        response.data === "Full Refund Request Successfull" ||
        response.data === "Partial Refund Successfull" ||
        response.data === "Full Refund Request Successfull without Addon"
      ) {
        toast.success(response.data);
        handleCloseRefundModals();
        props.SetRefreshData(!props.RefreshData);
        return;
      }
      if (
        response.data ===
        "Data already exists for this OrderPaymentId and RefundTypeId."
      ) {
        toast.error("Already full refunded!");
        setOpenRefundPopup(false);
        setRefundReason("");
      } else if (response.data === "This order is already full refunded!") {
        toast.error(response.data);
      } else {
        toast.warning(response.data);
      }
      props.SetRefreshData(!props.RefreshData);
    } catch (error) {
      setLoading(false);
      toast.error("Error while submitting refund request: " + error.message);
    }
  };

  // Partial Refund Request - updated with utils
  const PartialRefundRequest = async () => {
    if (!checkForValidation()) return;
    if (selectedPartialRefundItems?.length === 0) {
      setRefundValidationError(true);
      return;
    }
    if (!userToken) {
      toast.error("No User Found!");
      return;
    }
    const userTokenDec = jwt_decode(userToken);
    // console.log(
    //   "calculatedTotalFoodItemPrice.toFixed(2)",
    //   calculatedTotalFoodItemPrice.toFixed(2)
    // );
    const loginUserId = userTokenDec?.UserId;
    const orderItemsWithPrices =
      selectedRowToRefund?.items
        ?.filter((item) =>
          selectedPartialRefundItems?.some(
            (selected) => selected.orderItemId === item.orderItemId,
          ),
        )
        .map((item) => {
          const isAltered = alteredQuantity.some(
            (aq) => aq.orderItemId === item.orderItemId,
          );
          const refundQty = isAltered
            ? alteredQuantity.find((aq) => aq.orderItemId === item.orderItemId)
                ?.quantity || item.qty
            : item.qty;
          const selectedAddonsIds = addOnToRefund
            .filter((a) => a.orderItemId === item.orderItemId)
            .map((a) => a.id);
          const nonRefundedAddons =
            item.addons?.filter((ad) => ad.refundStatus !== "Refunded") || [];
          const selAddonsForPayload = isAltered
            ? nonRefundedAddons.filter((ad) =>
                selectedAddonsIds.includes(ad.id),
              )
            : nonRefundedAddons;
          const { itemTips, itemSC, itemSCVat } = getRefundableItemPrices(
            item,
            refundQty,
            selectedRowToRefund,
          );
          const addonPayloads = selAddonsForPayload.map((addon) => {
            console.log("addon?.options?", addon?.options);
            const addonFullPrice = getAddonTotalPrice(addon);
            // const { addonTips, addonSC, addonSCVat } =
            //   getRefundableAddonAmounts(addonFullPrice, selectedRowToRefund);
            const addonTips = addon.remainingTips;
            const addonSC = addon.remainingServiceCharge;
            const addonSCVat = addon.remainingServiceChargeVAT;
            return {
              addOnId: addon.id,
              addOnPrice: addon.totalPrice,
              AddOnTipsAmount: addonTips,
              AddOnServiceChargeAmount: addonSC,
              AddOnServiceChargeVatAmount: addonSCVat,
              addOnQuantity: parseInt(addon?.qty || 1),
              options:
                addon?.options?.map((option) => ({
                  optionId: option.optionId,
                  optionPrice: option.totalPrice,
                  optionQty: parseInt(option.qty || 1),
                  subOptions:
                    option?.subOptions?.map((subOption) => ({
                      subOptionId: subOption.subOptionId,
                      subOptionPrice: subOption.totalPrice,
                      subOptionQty: parseInt(subOption?.subOptionQuantity ?? 1),
                    })) || null,
                })) || null,
            };
          });
          return {
            orderItemId: item.orderItemId,
            totalPrice: (
              (item.basePrice + item.vatInAmount + item.sdInAmount) *
              refundQty
            ).toFixed(2),
            tipsAmount: itemTips,
            serviceChargeAmount: itemSC,
            ServiceChargeVatAmount: itemSCVat,
            quantity: refundQty,
            initialQuantity: item.qty,
            addOns: addonPayloads.length > 0 ? addonPayloads : null,
          };
        }) || [];
    const payload = {
      orderPaymentId: selectedRowToRefund.orderPaymentId,
      orderStatus: "Transaction/FullRefund",
      refundTypeId: "2",
      refundFromOrderId: "",
      refundAmount: calculatedTotalFoodItemPrice,
      refundReasonDescription: refundReason,
      creatorId: loginUserId,
      processingType: selectedRefundProcessingType?.label,
      emailAddress: "demoEmail",
      refundItems: orderItemsWithPrices,
      refundStatus: "RS002",
    };
    try {
      setLoading(true);
      const response = await axios.post(
        `${apiAddress}/api/OrderRefund/OrderPartialRefund`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );
      setLoading(false);
      if (
        response.data === "This order is already full refunded!" ||
        response.data === "Full Refund Found" ||
        response.data === "Items already refunded!" ||
        response.data === "No refund items provided." ||
        response.data === "Addons alredy refunded"
      ) {
        toast.error(response.data);
        return;
      }
      if (response.data === "OrderPartialRefund request failed") {
        toast.error(response.data);
        setOpenPartialRefundModal(false);
        setRefundReason("");
      } else {
        toast.success(response.data);
        setOpenPartialRefundModal(false);
        setRefundReason("");
      }
      handleCloseRefundModals();
      props.SetRefreshData(!props.RefreshData);
    } catch (error) {
      setLoading(false);
      toast.error(
        "Error while submitting partial refund request: " + error.message,
      );
    }
  };

  // Similar updates for WithdrawRefundRequest and WithdrawPartialRefundRequest
  // (omitted for brevity, but apply same pattern: use getRefundableItemPrices, getRefundableAddonAmounts, getAddonTotalPrice for payload)
  const WithdrawRefundRequest = async () => {
    if (selectedTransactionToRefundFrom?.length === 0) {
      setRefundValidationError(true);
      toast.error("Please select transaction to refund from");
      setHasRemainingAmount(false);
      return;
    }
    if (hasRemainingAmount) {
      if (selectedRestaurant === null || selectedBank === null) {
        setRefundValidationError(true);
        return;
      }
    }
    if (!checkForValidation()) return;
    const orderItemsWithPrices =
      selectedRowToRefund?.items
        ?.filter((item) => item.qty !== 0 && item.refundStatus !== "Refunded")
        ?.map((item) => {
          const refundQty = item.qty;
          const selectedAddons =
            item.addons?.filter((ad) => ad.refundStatus !== "Refunded") || [];
          const { itemTips, itemSC, itemSCVat } = getRefundableItemPrices(
            item,
            refundQty,
            selectedRowToRefund,
          );
          const addonPayloads = selectedAddons.map((addon) => {
            const addonFullPrice = getAddonTotalPrice(addon);
            // const { addonTips, addonSC, addonSCVat } =
            //   getRefundableAddonAmounts(
            //     addonFullPrice,
            //     selectedRowToRefund,
            //     selectedAddons,
            //     null
            //   );
            const addonTips = addon.remainingTips;
            const addonSC = addon.remainingServiceCharge;
            const addonSCVat = addon.remainingServiceChargeVAT;
            return {
              addOnId: addon.id,
              addOnPrice: addon.totalPrice,
              AddOnTipsAmount: addonTips,
              AddOnServiceChargeAmount: addonSC,
              AddOnServiceChargeVatAmount: addonSCVat,
              addOnQuantity: parseInt(addon?.qty || 1),
              options:
                addon?.options?.map((option) => ({
                  optionId: option.optionId,
                  optionPrice: option.totalPrice,
                  optionQty: parseInt(option.qty || 1),
                  subOptions:
                    option?.subOptions?.map((subOption) => ({
                      subOptionId: subOption.subOptionId,
                      subOptionPrice: subOption.totalPrice,
                      subOptionQty: parseInt(subOption?.subOptionQuantity ?? 0),
                    })) || null,
                })) || null,
            };
          });
          return {
            orderItemId: item.orderItemId,
            totalPrice: (
              (item.basePrice + item.sdInAmount + item.vatInAmount) *
              item.qty
            ).toFixed(2),
            TipsAmount: itemTips,
            ServiceChargeAmount: itemSC,
            ServiceChargeVatAmount: itemSCVat,
            quantity: item.qty,
            addOns: addonPayloads.length > 0 ? addonPayloads : null,
          };
        }) || [];
    const decoded = jwt_decode(userToken);
    const loginUserId = decoded?.UserId;
    const totalFees = parseFloat(
      (selectedRowToRefund?.totalTransactionFees ?? 0).toFixed(2),
    );
    const remainingAmount = parseFloat(
      (
        (selectedRowToRefund?.totalPrice ?? 0) -
        (selectedRowToRefund?.totalWithdrawnAmount ?? 0) -
        totalFees
      ).toFixed(2),
    );
    let totalAmountToRefundFromSelectedTransactions = !alreadyPartialRefunded
      ? (selectedRowToRefund?.totalPrice ?? 0) - (remainingAmount ?? 0)
      : calculatedTotalFoodItemPrice;
    let remainingRefund = totalAmountToRefundFromSelectedTransactions;
    const orderTransactionWithRefundableAmount =
      selectedTransactionToRefundFrom?.map((transaction) => {
        let matchAmount = 0;
        if (remainingRefund > 0) {
          if (transaction.netAmount <= remainingRefund) {
            matchAmount = transaction.netAmount;
            remainingRefund -= transaction.netAmount;
          } else {
            matchAmount = remainingRefund;
            remainingRefund = 0;
          }
        }
        return {
          amount: transaction.netAmount,
          matchAmount,
          receivedAmount: transaction.netAmount - matchAmount,
          totalServiceCharge: transaction.totalServiceCharge,
          totalServiceChargeVat: transaction.totalServiceChargeVat,
          totalTips: transaction.totalTips,
          transactionId: transaction.id,
          paymentId: transaction.orderPaymentId,
        };
      });
    const payload = {
      OrderId: selectedRowToRefund.id,
      orderPaymentId: selectedRowToRefund.orderPaymentId,
      orderStatus: "Withdraw",
      refundTypeId: "3",
      refundAmount: !alreadyPartialRefunded
        ? (
            selectedRowToRefund?.totalItemPrice +
            selectedRowToRefund?.totalTips +
            selectedRowToRefund?.totalServiceCharge +
            selectedRowToRefund?.totalServiceChargeVat
          ).toFixed(2)
        : CalculateTotalRefundAmountManually(selectedRowToRefund),
      refundReasonDescription: refundReason,
      creatorId: loginUserId.toString(),
      refundItems: orderItemsWithPrices,
      processingType: selectedRefundProcessingType?.label,
      emailAddress: "demoEmail",
      refundStatus: "RS002",
      refundFromTransactionWithAmount: orderTransactionWithRefundableAmount,
      restaurantId: selectedRestaurant?.id,
      bankDetailsId: selectedBank?.id,
      withdrawTypes: "WT001",
      matchOrderId: selectedRowToRefund.id,
    };
    try {
      setLoading(true);
      const result = await axios.post(
        `${apiAddress}/api/OrderRefund/OrderWithdrawRefund`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );
      setLoading(false);
      if (
        result.data ===
          "One of the selected transactions was already used for a refund. Please select a different combination to process the refund." ||
        result.data === "Withdraw Reqest Failed" ||
        result.data === "Data already exists for this OrderPaymentId"
      ) {
        toast.info(result.data);
      } else {
        toast.success(result.data);
        setOpenWithdrawRefundModal(false);
        setRefundReason("");
        setSelectedPartialRefundItems([]);
        setAllowWithdrawRefund(false);
        handleCloseRefundModals();
        props.SetRefreshData(!props.RefreshData);
      }
    } catch (error) {
      setLoading(false);
      toast.error(
        "Error while submitting withdraw refund request: " + error.message,
      );
    }
  };

  const WithdrawPartialRefundRequest = async () => {
    if (selectedTransactionToRefundFrom?.length === 0) {
      setRefundValidationError(true);
      toast.error("Please select transaction to refund from");
      return;
    }
    if (hasRemainingAmount) {
      if (selectedRestaurant === null || selectedBank === null) {
        setRefundValidationError(true);
        return;
      }
    }
    if (!checkForValidation()) return;
    const orderItemsWithPrices =
      selectedRowToRefund?.items
        ?.filter((item) =>
          selectedPartialRefundItems?.some(
            (selected) => selected.orderItemId === item.orderItemId,
          ),
        )
        .map((item) => {
          const isAltered = alteredQuantity.some(
            (aq) => aq.orderItemId === item.orderItemId,
          );
          const refundQty = isAltered
            ? alteredQuantity.find((aq) => aq.orderItemId === item.orderItemId)
                ?.quantity || item.qty
            : item.qty;
          const selectedAddonsIds = addOnToRefund
            .filter((a) => a.orderItemId === item.orderItemId)
            .map((a) => a.id);
          const nonRefundedAddons =
            item.addons?.filter((ad) => ad.refundStatus !== "Refunded") || [];
          const selAddonsForPayload = isAltered
            ? nonRefundedAddons.filter((ad) =>
                selectedAddonsIds.includes(ad.id),
              )
            : nonRefundedAddons;
          const { itemTips, itemSC, itemSCVat } = getRefundableItemPrices(
            item,
            refundQty,
            selectedRowToRefund,
          );
          const addonPayloads = selAddonsForPayload.map((addon) => {
            const addonFullPrice = getAddonTotalPrice(addon);
            // const { addonTips, addonSC, addonSCVat } =
            const addonTips = addon.remainingTips;
            const addonSC = addon.remainingServiceCharge;
            const addonSCVat = addon.remainingServiceChargeVAT;
            // getRefundableAddonAmounts(addonFullPrice, selectedRowToRefund);
            return {
              addOnId: addon.id,
              addOnPrice: addon.totalPrice,
              AddOnTipsAmount: addonTips,
              AddOnServiceChargeAmount: addonSC,
              AddOnServiceChargeVatAmount: addonSCVat,
              addOnQuantity: parseInt(addon.qty || 1),
              options:
                addon?.options?.map((option) => ({
                  optionId: option.optionId,
                  optionPrice: option.totalPrice,
                  optionQty: parseInt(option.qty || 1),
                  subOptions:
                    option?.subOptions?.map((subOption) => ({
                      subOptionId: subOption.subOptionId,
                      subOptionPrice: subOption.totalPrice,
                      subOptionQty: parseInt(subOption.subOptionQuantity ?? 0),
                    })) || [],
                })) || [],
            };
          });
          return {
            orderItemId: item.orderItemId,
            totalPrice: (
              (item.basePrice + item.vatInAmount + item.sdInAmount) *
              refundQty
            ).toFixed(2),
            tipsAmount: itemTips,
            serviceChargeAmount: itemSC,
            serviceChargeVatAmount: itemSCVat,
            quantity: refundQty,
            initialQuantity: item.qty,
            addOns: addonPayloads.length > 0 ? addonPayloads : null,
          };
        }) || [];
    const tokenUser = localStorage.getItem("gotasteadmintoken");
    let UserId = "";
    if (tokenUser) {
      const decoded = jwt_decode(tokenUser);
      UserId = decoded?.UserId;
    }
    const totalFees = parseFloat(
      (selectedRowToRefund?.totalTransactionFees ?? 0).toFixed(2),
    );
    const remainingAmount = parseFloat(
      (
        (selectedRowToRefund?.totalPrice ?? 0) -
        (selectedRowToRefund?.totalWithdrawnAmount ?? 0) -
        totalFees
      ).toFixed(2),
    );
    let totalAmountToRefundFromSelectedTransactions =
      calculatedTotalFoodItemPrice.toFixed(2);
    let remainingRefund = parseFloat(
      totalAmountToRefundFromSelectedTransactions,
    );
    const orderTransactionWithRefundableAmount =
      selectedTransactionToRefundFrom?.map((transaction) => {
        let matchAmount = 0;
        if (remainingRefund > 0) {
          if (transaction.netAmount <= remainingRefund) {
            matchAmount = transaction.netAmount;
            remainingRefund -= transaction.netAmount;
          } else {
            matchAmount = remainingRefund;
            remainingRefund = 0;
          }
        }
        return {
          amount: transaction.netAmount,
          matchAmount,
          receivedAmount: transaction.netAmount - matchAmount,
          totalServiceCharge: transaction.totalServiceCharge,
          totalServiceChargeVat: transaction.totalServiceChargeVat,
          totalTips: transaction.totalTips,
          transactionId: transaction.id,
          paymentId: transaction.orderPaymentId,
        };
      });
    const payload = {
      OrderId: selectedRowToRefund.id,
      orderPaymentId: selectedRowToRefund.orderPaymentId,
      orderStatus: "Withdraw",
      refundTypeId: "4",
      refundAmount: calculatedTotalFoodItemPrice,
      refundReasonDescription: refundReason,
      creatorId: UserId,
      refundItems: orderItemsWithPrices,
      processingType: selectedRefundProcessingType?.label,
      emailAddress: "demoEmail",
      refundStatus: "RS002",
      refundFromTransactionWithAmount: orderTransactionWithRefundableAmount,
      restaurantId: selectedRestaurant?.id,
      bankDetailsId: selectedBank?.id,
      withdrawTypes: "WT001",
      matchOrderId: selectedRowToRefund.id,
    };
    try {
      setLoading(true);
      const response = await axios.post(
        `${apiAddress}/api/OrderRefund/OrderWithdrawPartialRefund`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );
      setLoading(false);
      if (
        response.data === "Full Withdraw Refund Exists" ||
        response.data === "Items Already Refunded" ||
        response.data ===
          "One of the selected transactions was already used for a refund. Please select a different combination to process the refund." ||
        response.data === "Failed to make a partial request" ||
        response.data === "Failed to make withdraw-refund request" ||
        response.data === "Addon is alreday refunded"
      ) {
        toast.error(response.data);
      } else {
        toast.success(response.data);
        setOpenWithdrawRefundModal(false);
        setRefundReason("");
        setSelectedPartialRefundItems([]);
        setAllowWithdrawRefund(false);
        setWithdrawPartialRefundOnAction(false);
        handleCloseRefundModals();
        props.SetRefreshData(!props.RefreshData);
      }
    } catch (error) {
      setLoading(false);
      toast.error(
        "Error while submitting withdraw partial refund request: " +
          error.message,
      );
    }
  };

  // Check if already partial refunded
  useEffect(() => {
    if (selectedRowToRefund?.items) {
      setAlreadyPartialRefunded(
        selectedRowToRefund.items.some((item) => item.qty !== item.initialQty),
      );
    }
  }, [selectedRowToRefund]);

  // Updated total calculation using utils
  useEffect(() => {
    if (selectedPartialRefundItems.length === 0) {
      setCalculatedTotalFoodItemPrice(0);
      return;
    }
    const total = calculateTotalRefundAmount(
      selectedPartialRefundItems,
      selectedRowToRefund,
      (item) => {
        const altered = alteredQuantity.find(
          (aq) => aq.orderItemId === item.orderItemId,
        );
        return altered ? altered.quantity : item.qty;
      },
      (item) => addOnToRefund.filter((a) => a.orderItemId === item.orderItemId),
    );

    console.log("Khalid 123 selectedRowToRefund", selectedRowToRefund);
    console.log(
      "Khalid 123 selectedPartialRefundItems",
      selectedPartialRefundItems,
    );
    let totalPrice = 0.0;

    selectedPartialRefundItems.forEach((item) => {
      totalPrice +=
        (item.itemPrice || 0) +
        (item.serviceCharge || 0) +
        (item.serviceChargeVat || 0) +
        (item.tips || 0);

      item.addons?.forEach((addon) => {
        totalPrice +=
          (addon.addOnPrice || 0) +
          (addon.remainingServiceCharge || 0) +
          (addon.remainingServiceChargeVAT || 0) +
          (addon.remainingTips || 0);

        addon.options?.forEach((option) => {
          totalPrice += option.optionPrice || 0;

          option.subOptions?.forEach((subOption) => {
            totalPrice += subOption.subOptionPrice || 0;
          });
        });
      });
    });

    console.log("Khalid 123 addon totalPrice", totalPrice);

    console.log("Khalid 123 test12", total);
    setCalculatedTotalFoodItemPrice(total);
  }, [
    selectedPartialRefundItems,
    alteredQuantity,
    addOnToRefund,
    selectedRowToRefund,
  ]);

  // Check for refunded transactions
  useEffect(() => {
    if (row.length !== 0) {
      if (row?.transactions?.some((txn) => txn.type === "Withdraw")) {
        setShowRefundFromOtherOrder(true);
      } else {
        setShowRefundFromOtherOrder(false);
      }
    }
  }, [row]);

  // Check to allow refundable withdraw - restored original logic with minor improvements (use let/const, fix typos)
  useEffect(() => {
    if (selectedTransactionToRefundFrom.length === 0) return;

    let totalPriceAccumulated = 0;
    selectedTransactionToRefundFrom.forEach((transaction) => {
      totalPriceAccumulated += transaction?.netAmount || 0;
    });

    if (totalPriceAccumulated < 0) {
      setCheckForRequiredAmountToWithdraw("Please Select another transaction");
      setAllowWithdrawRefund(false);
      return;
    }

    if (!withdrawPartialRefundOnAction) {
      setAllowWithdrawRefund(false);
      const remainingAmountOfSelectedOrderToRefund =
        (selectedRowToRefund?.totalPrice || 0) -
        (selectedRowToRefund?.totalTransactionFees || 0) -
        (selectedRowToRefund?.totalWithdrawnAmount || 0);
      const refundAmount =
        parseFloat(CalculateTotalRefundAmountManually(selectedRowToRefund)) -
        remainingAmountOfSelectedOrderToRefund;

      if (totalPriceAccumulated < refundAmount) {
        setCheckForRequiredAmountToWithdraw(
          "*Please select another transaction to refund",
        );
      } else if (totalPriceAccumulated === refundAmount) {
        setAllowWithdrawRefund(true);
        setCheckForRequiredAmountToWithdraw(
          `Need to Refund ￡${(selectedRowToRefund?.totalPrice || 0).toFixed(
            2,
          )} - Remaining withdraw amount: ￡${(
            totalPriceAccumulated - (selectedRowToRefund?.totalPrice || 0)
          ).toFixed(2)}`,
        );
      } else if (totalPriceAccumulated - refundAmount < 0) {
        setHasRemainingAmount(false);
        setAllowWithdrawRefund(false);
        setCheckForRequiredAmountToWithdraw(
          `Remaining withdraw amount: ￡${(
            totalPriceAccumulated - (selectedRowToRefund?.totalPrice || 0)
          ).toFixed(2)}`,
        );
      } else {
        setHasRemainingAmount(true);
        setAllowWithdrawRefund(true);
        setCheckForRequiredAmountToWithdraw(
          `Remaining withdraw amount: ￡${(
            totalPriceAccumulated - refundAmount
          ).toFixed(2)}`,
        );
      }
    } else {
      setAllowWithdrawRefund(false);
      if (totalPriceAccumulated < calculatedTotalFoodItemPrice) {
        setCheckForRequiredAmountToWithdraw(
          "*Please select another transaction to refund",
        );
      } else if (totalPriceAccumulated === calculatedTotalFoodItemPrice) {
        setAllowWithdrawRefund(true); // Added to set true for exact match
      } else if (totalPriceAccumulated - calculatedTotalFoodItemPrice < 0) {
        setHasRemainingAmount(false);
        setAllowWithdrawRefund(false);
        setCheckForRequiredAmountToWithdraw(
          `Remaining withdraw amount: ￡${(
            totalPriceAccumulated - calculatedTotalFoodItemPrice
          ).toFixed(2)}`,
        );
      } else {
        setHasRemainingAmount(true);
        setAllowWithdrawRefund(true);
        setCheckForRequiredAmountToWithdraw(
          `Remaining withdraw amount: ￡${(
            totalPriceAccumulated - calculatedTotalFoodItemPrice
          ).toFixed(2)}`,
        );
      }
    }
  }, [
    selectedTransactionToRefundFrom,
    withdrawPartialRefundOnAction,
    selectedRowToRefund,
    calculatedTotalFoodItemPrice,
  ]);

  const getBankDetails = async (restaurantId) => {
    try {
      const response = await axios.get(
        `${apiAddress}/api/RestaurantBankDetails/${restaurantId}`,
      );
      setBankDetailsList(response.data);
    } catch (error) {
      console.error("Bank details fetching error", error);
    }
  };

  useEffect(() => {
    if (restaurantToken) {
      const parsed = JSON.parse(restaurantToken);
      setSelectedRestaurant(parsed);
    }
  }, [hasRemainingAmount, restaurantToken]); // Added restaurantToken to deps

  useEffect(() => {
    if (selectedRestaurant?.id) {
      getBankDetails(selectedRestaurant.id);
    }
  }, [selectedRestaurant]);

  const withdrawRefundTransactionSelection = (newValue) => {
    const seen = new Set();
    const processed = newValue
      .filter((t) => {
        if (seen.has(t.id)) return false;
        seen.add(t.id);
        return true;
      })
      .map((t) => ({
        ...t,
        netAmount:
          (t.totalPrice || 0) -
          (t.totalTransactionFees || 0) -
          (t.totalWithdrawnAmount || 0),
      }));
    setSelectedTransactionToRefundFrom(processed);
  };

  useEffect(() => {
    const fetchUsedTransactions = async () => {
      try {
        const result = await axios.get(
          `${apiAddress}/api/OrderRefund/GetAlreadyUsedTransactions`,
        );
        setAlreadyUsedTransactionToRefund(result.data);
      } catch (error) {
        console.error("Error fetching used transactions", error);
      }
    };
    fetchUsedTransactions();
  }, []);

  const GetAllTransaction = () => {
    const now = new Date();
    const twentyFourHoursAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000);
    const preparedData = props?.TotalData?.filter(
      (data) =>
        !alreadyUsedTransactionToRefund?.some(
          (used) => used.refundedFromOrderId === data.id,
        ),
    );
    const validToRefundFrom = preparedData.filter(
      (element) =>
        !element.transactions.some(
          (trans) => trans.type === "Withdraw" || trans.type === "Refund",
        ),
    );
    return validToRefundFrom
      ?.filter(
        (item) =>
          item?.id !== selectedRowToRefund?.id &&
          item?.transactionStatus === "Transaction" &&
          new Date(item?.orderCompletionDateTime) < twentyFourHoursAgo,
      )
      .map((transaction) => ({
        ...transaction,
        netAmount:
          (transaction.totalPrice || 0) -
          (transaction.totalTransactionFees || 0) -
          (transaction.totalWithdrawnAmount || 0),
      }));
  };

  const refundProcessingType = [
    { id: 1, label: "Bank" },
    { id: 2, label: "Card (charge £0.20p)" },
  ];

  const handleCheckboxSelection = (data) => {
    toast.info("You have selected item: ");
    console.log("data", data);
    const found = selectedPartialRefundItems?.some(
      (item) => item.orderItemId === data.orderItemId,
    );
    if (found) {
      const filteredItems = selectedPartialRefundItems.filter(
        (item) => item.orderItemId !== data.orderItemId,
      );
      setSelectedPartialRefundItems(filteredItems);
      const filteredAddOns = addOnToRefund.filter(
        (ad) => ad.orderItemId !== data.orderItemId,
      );
      setAddOnToRefund(filteredAddOns);
      const filteredQty = alteredQuantity.filter(
        (aq) => aq.orderItemId !== data.orderItemId,
      );
      setAlteredQuantity(filteredQty);
    } else {
      setSelectedPartialRefundItems((prev) => [...prev, data]);
      const addonsWithId =
        data.addons?.map((ad) => ({ ...ad, orderItemId: data.orderItemId })) ||
        [];
      setAddOnToRefund((prev) => [...prev, ...addonsWithId]);
    }
  };

  const handleQuantityChange = (instruction, data) => {
    const searchItem = selectedPartialRefundItems.find(
      (item) => item.orderItemId === data.orderItemId,
    );
    if (!searchItem) {
      toast.info("Please select this item to modify");
      return;
    }
    const foundIndex = alteredQuantity.findIndex(
      (aq) => aq.orderItemId === data.orderItemId,
    );
    let preparedData;
    if (foundIndex !== -1) {
      const updated = [...alteredQuantity];
      const selectedData = updated[foundIndex].quantity;
      preparedData = {
        orderItemId: data.orderItemId,
        quantity: instruction === "+" ? selectedData + 1 : selectedData - 1,
      };
      if (preparedData.quantity === data.qty) {
        const filteredAddOns = data.addons
          .filter(
            (addon) =>
              addon.refundStatus !== "Refunded" &&
              !addOnToRefund.some((existing) => existing.id === addon.id),
          )
          .map((ad) => ({ ...ad, orderItemId: data.orderItemId }));
        setAddOnToRefund((prev) => [...prev, ...filteredAddOns]);
      }
      if (preparedData.quantity > data.qty || preparedData.quantity <= 0) {
        return;
      }
      updated[foundIndex] = preparedData;
      setAlteredQuantity(updated);
    } else {
      preparedData = {
        orderItemId: data.orderItemId,
        quantity: instruction === "+" ? data.qty + 1 : data.qty - 1,
      };
      if (preparedData.quantity === data.qty) {
        const filteredAddOns = data.addons
          .filter(
            (addon) =>
              addon.refundStatus !== "Refunded" &&
              !addOnToRefund.some((existing) => existing.id === addon.id),
          )
          .map((ad) => ({ ...ad, orderItemId: data.orderItemId }));
        setAddOnToRefund((prev) => [...prev, ...filteredAddOns]);
      }
      if (preparedData.quantity > data.qty || preparedData.quantity <= 0) {
        return;
      }
      setAlteredQuantity((prev) => [...prev, preparedData]);
    }
  };

  const handleAddonCheckbox = (addon, orderItemId) => {
    const found = addOnToRefund.some((item) => item.id === addon.id);
    if (found) {
      const filtered = addOnToRefund.filter((item) => item.id !== addon.id);
      setAddOnToRefund(filtered);
    } else {
      setAddOnToRefund((prev) => [...prev, { ...addon, orderItemId }]);
    }
  };

  // Updated useEffect for adding all addons when qty full
  useEffect(() => {
    if (alteredQuantity.length === 0 || !selectedRowToRefund) return;
    let foodItems;
    let find;
    selectedRowToRefund?.items?.forEach((item) => {
      find = alteredQuantity.find(
        (qtyItem) => qtyItem.orderItemId === item.orderItemId,
      );
      if (find) {
        foodItems = item;
        return;
      }
    });
    if (!find || !foodItems) return;
    const check = find.quantity === foodItems.qty;
    if (check) {
      foodItems.addons?.forEach((addon) => {
        if (addon.refundStatus === "Refunded") return;
        setAddOnToRefund((prevValue) => {
          const alreadyExist = prevValue.some(
            (existing) => existing.id === addon.id,
          );
          if (!alreadyExist) {
            return [
              ...prevValue,
              { ...addon, orderItemId: foodItems.orderItemId },
            ];
          }
          return prevValue;
        });
      });
    }
  }, [alteredQuantity, selectedRowToRefund]);

  // Utility functions (improved with safer defaults)
  const calculateWithdrawnAmount = (trans) => {
    const withdrawTransactions =
      trans?.filter((item) => item.type === "Withdraw") || [];
    return withdrawTransactions.reduce(
      (sum, item) => sum + (parseFloat(item.transactionAmount) || 0),
      0,
    );
  };

  const getTotalRefundedAmount = (rowTrans) => {
    const refunded = rowTrans?.filter((item) => item.type === "Refund") || [];
    return refunded.reduce(
      (sum, item) => sum + (parseFloat(item.transactionAmount) || 0),
      0,
    );
  };

  const CheckWithdrawableAmount = (rowData) => {
    if (rowData.transactionStatus !== "Transaction") return "N/A";
    const totalOrderPrice =
      (parseFloat(rowData.totalPrice) || 0) -
      (parseFloat(rowData.totalTransactionFees) || 0);
    const hasWithdraw = rowData?.transactions?.some(
      (trans) => trans?.type === "Withdraw",
    );
    const hasRefund = rowData?.transactions?.some(
      (trans) => trans?.type === "Refund",
    );
    const withdrawable = calculateWithdrawnAmount(rowData?.transactions);
    const refundedAmount = getTotalRefundedAmount(rowData?.transactions);
    console.log("Khalid 12345 rowData.totalPrice", rowData.totalPrice);
    console.log("Khalid 12345 totalOrderPrice", totalOrderPrice);
    console.log("Khalid 12345 withdrawable", withdrawable);
    console.log("Khalid 12345 refundedAmount", refundedAmount);
    if (hasWithdraw && hasRefund) {
      return (totalOrderPrice + refundedAmount + withdrawable).toFixed(2);
    }
    if (hasWithdraw) {
      return (totalOrderPrice + withdrawable).toFixed(2);
    }
    if (hasRefund) {
      return (totalOrderPrice + refundedAmount).toFixed(2);
    }
    return totalOrderPrice.toFixed(2);
  };

  const GetSubTotal = (rowData) => {
    return (
      rowData?.items?.reduce(
        (acc, item) => acc + (parseFloat(item.itemPrice) || 0),
        0,
      ) || 0
    ).toFixed(2);
  };

  const getEffectiveOrderStatus = (rowData) => {
    const totalAmount = parseFloat(rowData.totalPrice) || 0;
    const totalRefunded = parseFloat(rowData.totalRefundedAmount) || 0;

    // Fully refunded — override to "Refunded"
    if (Math.abs(totalAmount - totalRefunded) === 0) {
      // tolerance for float precision
      return "Refunded";
    }

    // Otherwise fallback to original logic
    if (rowData.transactionStatus === "Withdraw") {
      return "Withdrawal";
    }

    // Keep current logic for other statuses
    if (rowData.transactions?.some((txn) => txn.type === "Withdraw")) {
      return "Withdrawn"; // or keep as badge like before
    }

    return rowData.orderStatus || "Pending";
  };

  // Render (main table row and sub-tables remain the same, except pass updated props to modals)
  return (
    <>
      <ToastContainer />
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell
          sx={{ position: "sticky", left: 0, background: "#fff", zIndex: 2 }}
        >
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell
          sx={{ position: "sticky", left: 56, background: "#fff", zIndex: 2 }}
          align="left"
        >
          <span>#{row?.id?.slice(-6)}</span>
        </TableCell>
        <TableCell
          // sx={{ position: "sticky", left: 154, background: "#fff", zIndex: 2 }}
          align="center"
          style={{ textWrap: "nowrap" }}
        >
          {row.transactionStatus === "Withdraw"
            ? "Withdrawal"
            : row.transactionStatus}
        </TableCell>
        <TableCell align="center" style={{ textWrap: "nowrap" }}>
          {(() => {
            const totalAmount = parseFloat(row.totalPrice) || 0;
            const totalRefunded = parseFloat(row.totalRefundedAmount) || 0;
            const isFullyRefunded =
              Math.abs(totalAmount - totalRefunded) < 0.01;

            // Only auto-set "Refunded" for "Transaction"-type rows
            if (
              row.transactionStatus === "Transaction" &&
              isFullyRefunded &&
              !row?.transactions?.some((txn) => txn.type === "Withdraw")
            ) {
              return (
                <span
                  style={{ color: "red", fontSize: "12px", fontWeight: "bold" }}
                >
                  Refunded
                </span>
              );
            }

            // Otherwise, preserve original logic:
            if (row?.transactions?.some((txn) => txn.type === "Withdraw")) {
              return (
                <span
                  style={{
                    color: "blue",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  Withdrawn
                </span>
              );
            }

            return (
              <span
                style={{
                  color: row.orderStatus === "Ready" ? "green" : "#FFE135",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                {row.orderStatus}
              </span>
            );
          })()}

          {/* Keep the suffixes as before */}
          <span
            style={{
              color: row.withdrawStatus === "Approved" ? "green" : "#FFE135",
              fontSize: "12px",
              fontWeight: "bold",
            }}
          >
            {row.transactionStatus === "Withdraw" ? row.withdrawStatus : ""}
          </span>
          <span style={{ fontSize: "12px", fontWeight: "bold" }}>
            {row.transactionStatus === "Refund" ? "N/A" : ""}
          </span>
        </TableCell>
        <TableCell align="center">
          {(() => {
            const dateObj = new Date(row.transactionDateTime);
            const dateStr = dateObj.toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            });
            const timeStr = dateObj.toLocaleTimeString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            });
            return (
              <>
                <span>{timeStr}</span>
                <br />
                <span>{dateStr}</span>
              </>
            );
          })()}
        </TableCell>
        <TableCell align="center">
          {(() => {
            const dateObj = new Date(row.orderCompletionDateTime);
            const dateStr = dateObj.toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            });
            const timeStr = dateObj.toLocaleTimeString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            });
            return (
              <>
                <span>{timeStr}</span>
                <br />
                <span>{dateStr}</span>
              </>
            );
          })()}
        </TableCell>
        <TableCell align="center">
          {row.transactionStatus === "Withdraw" ||
          row.transactionStatus === "Refund"
            ? "0.00"
            : "£ " + (row.totalVat || 0).toFixed(2)}
        </TableCell>
        <TableCell align="center">
          {row.transactionStatus === "Withdraw" ||
          row.transactionStatus === "Refund"
            ? "0.00"
            : "£ " + (row.totalSd || 0).toFixed(2)}
        </TableCell>
        <TableCell align="center">
          {(row.transactionStatus === "Withdraw" ? "- " : "") +
            "£ " +
            (row.totalServiceCharge || 0).toFixed(2)}
        </TableCell>
        <TableCell align="center">
          {(row.transactionStatus === "Withdraw" ? "- " : "") +
            "£ " +
            (row.totalServiceChargeVat || 0).toFixed(2)}
        </TableCell>
        <TableCell align="center">
          {(row.transactionStatus === "Withdraw" ? "- " : "") +
            "£ " +
            (row.totalTips || 0).toFixed(2)}
        </TableCell>
        <TableCell align="center">
          £ {(row.totalCredit || 0).toFixed(2)}
        </TableCell>
        <TableCell align="center">
          <span>
            £{" "}
            {row.transactionStatus === "Refund" ||
            row.transactionStatus === "Withdraw"
              ? "N/A"
              : GetSubTotal(row)}
          </span>
        </TableCell>
        <TableCell align="center">
          {(row.transactionStatus === "Withdraw" ? "- " : "") +
            "£ " +
            (row.totalPrice || 0).toFixed(2)}
        </TableCell>
        <TableCell align="center">
          £{" "}
          {row.transactionStatus === "Withdraw"
            ? "N/A"
            : (row.totalRefundedAmount || 0).toFixed(2)}
        </TableCell>
        <TableCell align="center">
          {row.transactionStatus !== "Refund"
            ? "£ " + (row.totalPlatformFees || 0).toFixed(2)
            : "£ 0.00"}
        </TableCell>
        <TableCell align="center">
          {row.transactionStatus === "Withdraw" ||
          row.transactionStatus === "Refund"
            ? "£ 0.00"
            : "£ " + (row.totalProcessingFees || 0).toFixed(2)}
        </TableCell>
        <TableCell align="center">
          {row.transactionStatus === "Withdraw" ||
          row.transactionStatus === "Refund"
            ? "£ 0.00"
            : "£ " + (row.totalCaptureFee || 0).toFixed(2)}
        </TableCell>
        <TableCell align="center">
          {row.transactionStatus === "Withdraw" ||
          row.transactionStatus === "Refund"
            ? "£ 0.00"
            : "£ " + (row.totalAuthorizationFee || 0).toFixed(2)}
        </TableCell>
        <TableCell align="center">
          {row.transactionStatus === "Withdraw" ||
          row.transactionStatus === "Refund"
            ? "£ 0.00"
            : "£ " + (row.totalGatewayFees || 0).toFixed(2)}
        </TableCell>
        <TableCell align="center">
          {row.transactionStatus === "Withdraw" ||
          row.transactionStatus === "Refund"
            ? "£ 0.00"
            : "£ " + (row.totalAssessmentFees || 0).toFixed(2)}
        </TableCell>
        <TableCell align="center">
          {row.transactionStatus === "Withdraw" ||
          row.transactionStatus === "Refund"
            ? "£ 0.00"
            : "£ " + (row.totalInterchangeFees || 0).toFixed(2)}
        </TableCell>
        <TableCell align="center">
          {row.transactionStatus === "Withdraw" ||
          row.transactionStatus === "Refund"
            ? "£ 0.00"
            : "£ " + (row.totalWithdrawFees || 0).toFixed(2)}
        </TableCell>
        <TableCell align="center">
          {row.transactionStatus === "Withdraw" ||
          row.transactionStatus === "Refund"
            ? "£ 0.00"
            : "£ " + (row.totalRefundFees || 0).toFixed(2)}
        </TableCell>
        <TableCell align="center">
          {row.transactionStatus === "Withdraw" ||
          row.transactionStatus === "Refund"
            ? "£ 0.00"
            : "£ " + (row.totalTransactionFees || 0).toFixed(2)}
        </TableCell>
        <TableCell align="center">
          {row.transactionStatus !== "Withdraw" &&
          row.transactionStatus !== "Refund" ? (
            <span>
              £{" "}
              {Math.abs(CheckWithdrawableAmount(row)) === 0.0
                ? "0.00"
                : CheckWithdrawableAmount(row)}
            </span>
          ) : (
            <span>N/A</span>
          )}
        </TableCell>
      </TableRow>
      {row.transactionStatus === "Transaction" && (
        <>
          <TableRow>
            <TableCell
              sx={{ paddingBottom: 0, paddingTop: 0, minWidth: "1060px" }}
              colSpan={6}
            >
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{ margin: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    Food Items
                  </Typography>
                  <Table size="small" aria-label="food-items">
                    <TableHead>
                      <TableRow>
                        <TableCell />
                        <TableCell align="left" className="fooditemTableHeader">
                          Item Name
                        </TableCell>
                        <TableCell
                          align="center"
                          className="fooditemTableHeader"
                        >
                          Refund Status
                        </TableCell>
                        <TableCell
                          align="center"
                          className="fooditemTableHeader"
                        >
                          Base Price
                        </TableCell>
                        <TableCell
                          align="center"
                          className="fooditemTableHeader"
                        >
                          Total Item SD
                        </TableCell>
                        <TableCell
                          align="center"
                          className="fooditemTableHeader"
                        >
                          Total Item Vat
                        </TableCell>
                        <TableCell
                          align="center"
                          className="fooditemTableHeader"
                        >
                          Item Quantity
                        </TableCell>
                        <TableCell
                          align="center"
                          className="fooditemTableHeader"
                        >
                          Total Tips
                        </TableCell>
                        <TableCell
                          align="center"
                          className="fooditemTableHeader"
                        >
                          Total Service Charge
                        </TableCell>
                        <TableCell
                          align="center"
                          className="fooditemTableHeader"
                        >
                          Total ServiceCharge Vat
                        </TableCell>
                        <TableCell
                          align="center"
                          className="fooditemTableHeader_lg"
                        >
                          Total Credit
                        </TableCell>
                        <TableCell
                          align="center"
                          className="fooditemTableHeader"
                        >
                          Sub Total (Inclusive addon)
                        </TableCell>
                        <TableCell
                          align="center"
                          className="fooditemTableHeader"
                        >
                          Total Amount
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {row?.items?.map((foodItem, index) => (
                        <FoodItemRow key={index} foodItem={foodItem} />
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Collapse>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{ margin: 1 }}>
                  <Typography variant="h6" gutterBottom>
                    Transaction History
                  </Typography>
                  <Table size="small" aria-label="food-items">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="center"
                          className="transactionsChildTableHeader"
                        >
                          Transaction Id
                        </TableCell>
                        <TableCell
                          align="center"
                          className="transactionsChildTableHeader_lg"
                        >
                          Date Time
                        </TableCell>
                        <TableCell
                          align="center"
                          className="transactionsChildTableHeader_lg"
                        >
                          Start Balance
                        </TableCell>
                        <TableCell
                          align="center"
                          className="transactionsChildTableHeader"
                        >
                          Transaction Amount
                        </TableCell>
                        <TableCell
                          align="center"
                          className="transactionsChildTableHeader"
                        >
                          Transaction Type
                        </TableCell>
                        <TableCell
                          align="center"
                          className="transactionsChildTableHeader"
                        >
                          Total Fees
                        </TableCell>
                        <TableCell
                          align="center"
                          className="transactionsChildTableHeader"
                        >
                          Withdrawable Balance
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {row?.transactions?.map((transaction, index) => (
                        <TransactionRow
                          key={index}
                          transaction={transaction}
                          transactions={row.transactions}
                        />
                      ))}
                    </TableBody>
                  </Table>
                </Box>
                <div className="d-flex align-items-center">
                  {!showRefundFromOtherOrder && (
                    <div>
                      <Button
                        id="fade-button"
                        aria-controls={openMenu ? "fade-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={openMenu ? "true" : undefined}
                        onClick={handleClick}
                      >
                        refund
                      </Button>
                      <Menu
                        id="fade-menu"
                        MenuListProps={{ "aria-labelledby": "fade-button" }}
                        anchorEl={anchorEl}
                        open={openMenu}
                        onClose={handleClose}
                        TransitionComponent={Fade}
                      >
                        <MenuItem onClick={() => FullRefundOnClick(row)}>
                          Full Refund
                        </MenuItem>
                        <MenuItem onClick={() => PartialRefundOnClick(row)}>
                          Partial Refund
                        </MenuItem>
                      </Menu>
                    </div>
                  )}
                  {showRefundFromOtherOrder && (
                    <div>
                      <Button
                        id="fade-button"
                        aria-controls={openMenu ? "fade-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={openMenu ? "true" : undefined}
                        onClick={handleClick}
                      >
                        refund
                      </Button>
                      <Menu
                        id="fade-menu"
                        MenuListProps={{ "aria-labelledby": "fade-button" }}
                        anchorEl={anchorEl}
                        open={openMenu}
                        onClose={handleClose}
                        TransitionComponent={Fade}
                      >
                        <MenuItem onClick={() => WithdrawRefundOnClick(row)}>
                          Refund from other order
                        </MenuItem>
                        <MenuItem
                          onClick={() => WithdrawPartialRefundOnClick(row)}
                        >
                          Partial refund from other order
                        </MenuItem>
                      </Menu>
                    </div>
                  )}
                </div>
              </Collapse>
            </TableCell>
          </TableRow>
        </>
      )}
      {row.transactionStatus === "Refund" && (
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1, minWidth: "fit-content !important" }}>
                <Typography variant="h6" gutterBottom>
                  Refund
                </Typography>
                <Table size="small" aria-label="food-items">
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      <TableCell align="left" className="retundTableHeader_lg">
                        Item Name
                      </TableCell>
                      <TableCell align="center" className="retundTableHeader">
                        Transaction Id
                      </TableCell>
                      <TableCell align="center" className="retundTableHeader">
                        Date Time
                      </TableCell>
                      <TableCell align="center" className="retundTableHeader">
                        Remain Quantity
                      </TableCell>
                      <TableCell align="center" className="retundTableHeader">
                        Refunded Quantity
                      </TableCell>
                      <TableCell align="center" className="retundTableHeader">
                        Refunded Amount
                      </TableCell>
                      <TableCell align="center" className="retundTableHeader">
                        Match Order
                      </TableCell>
                      <TableCell align="center" className="retundTableHeader">
                        Match amount
                      </TableCell>
                      <TableCell align="center" className="retundTableHeader">
                        Total amount
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row?.items?.map((foodItem, index) => (
                      <RefundedRow key={index} foodItem={foodItem} />
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
      {row.transactionStatus === "Withdraw" && (
        <TableRow>
          <TableCell
            style={{
              paddingBottom: 0,
              paddingTop: 0,
              minWidth: "1080px !important",
            }}
            colSpan={6}
          >
            <Collapse
              in={open}
              style={{ minWidth: "fit-content !important" }}
              timeout="auto"
              unmountOnExit
            >
              <Box sx={{ margin: 1, minWidth: "fit-content !important" }}>
                <Typography variant="h6" gutterBottom>
                  Withdrawal
                </Typography>
                <Table aria-label="food-items">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center" className="withdrawTableHeader">
                        Withdrawal Amount Type
                      </TableCell>
                      <TableCell align="center" className="withdrawTableHeader">
                        Transaction Id
                      </TableCell>
                      <TableCell align="center" className="withdrawTableHeader">
                        Date Time
                      </TableCell>
                      <TableCell align="center" className="withdrawTableHeader">
                        Total Withdrawn Amount
                      </TableCell>
                      <TableCell align="center" className="withdrawTableHeader">
                        Matched Refunded Order
                      </TableCell>
                      <TableCell align="center" className="withdrawTableHeader">
                        Matched Refunded Amount
                      </TableCell>
                      <TableCell align="center" className="withdrawTableHeader">
                        Total Withdraw Fees
                      </TableCell>
                      <TableCell align="center" className="withdrawTableHeader">
                        Total Matched Fees
                      </TableCell>
                      <TableCell align="center" className="withdrawTableHeader">
                        Total Received Amount
                      </TableCell>
                      <TableCell align="center" className="withdrawTableHeader">
                        Bank Account
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row?.withdrawDetails?.map((withdraw, index) => (
                      <WithdrawRow key={index} withdraws={withdraw} />
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
      {/* Modals - pass updated props */}
      {openRefundPopup && (
        <FullRefundModal
          openRefundPopup={openRefundPopup}
          handleCloseRefundModals={handleCloseRefundModals}
          itemImg={itemImg}
          SetOpenRefundPopup={setOpenRefundPopup}
          selectedRowToRefund={selectedRowToRefund}
          row={row}
          RefundProcessingType={refundProcessingType}
          RefundValidationError={RefundValidationError}
          RefundRequest={RefundRequest}
          setRefundReason={setRefundReason}
          refundReason={refundReason}
          selectedRefundProcessingType={selectedRefundProcessingType}
          setSelectedRefundProcessingType={setSelectedRefundProcessingType}
          emailAddressToSendRefundPaymentForm={
            emailAddressToSendRefundPaymentForm
          }
          setEmailAddressToSendRefundPaymentForm={
            setEmailAddressToSendRefundPaymentForm
          }
          refundProcessingTypeValidationError={
            refundProcessingTypeValidationError
          }
          emailValidationError={emailValidationError}
          CloseIcon={closeIcon}
          // Pass utils if needed for full modal
        />
      )}
      {openPartialRefundModal && (
        <PartialRefundModal
          openPartialRefundModal={openPartialRefundModal}
          handleCloseRefundModals={handleCloseRefundModals}
          itemImg={itemImg}
          SetOpenRefundPopup={setOpenRefundPopup}
          selectedRowToRefund={selectedRowToRefund}
          row={row}
          RefundProcessingType={refundProcessingType}
          RefundValidationError={RefundValidationError}
          setRefundReason={setRefundReason}
          refundReason={refundReason}
          addOnToRefund={addOnToRefund}
          setAddOnToRefund={setAddOnToRefund}
          selectedRefundProcessingType={selectedRefundProcessingType}
          setSelectedRefundProcessingType={setSelectedRefundProcessingType}
          emailAddressToSendRefundPaymentForm={
            emailAddressToSendRefundPaymentForm
          }
          setEmailAddressToSendRefundPaymentForm={
            setEmailAddressToSendRefundPaymentForm
          }
          closeIcon={closeIcon}
          calculatedTotalFoodItemPrice={calculatedTotalFoodItemPrice}
          handleCheckboxSelection={handleCheckboxSelection}
          selectedPartialRefundItems={selectedPartialRefundItems}
          alteredQuantity={alteredQuantity}
          handleQuantityChange={handleQuantityChange}
          handleAddonCheckbox={handleAddonCheckbox}
          refundProcessingType={refundProcessingType}
          PartialRefundRequest={PartialRefundRequest}
          refundProcessingTypeValidationError={
            refundProcessingTypeValidationError
          }
          emailValidationError={emailValidationError}
        />
      )}
      {openWithdrawRefundModal && (
        <MatchRefundModal
          openWithdrawRefundModal={openWithdrawRefundModal}
          handleCloseRefundModals={handleCloseRefundModals}
          itemImg={itemImg}
          SetOpenRefundPopup={setOpenRefundPopup}
          selectedRowToRefund={selectedRowToRefund}
          row={row}
          RefundProcessingType={refundProcessingType}
          RefundValidationError={RefundValidationError}
          setRefundReason={setRefundReason}
          refundReason={refundReason}
          addOnToRefund={addOnToRefund}
          selectedRefundProcessingType={selectedRefundProcessingType}
          setSelectedRefundProcessingType={setSelectedRefundProcessingType}
          emailAddressToSendRefundPaymentForm={
            emailAddressToSendRefundPaymentForm
          }
          setEmailAddressToSendRefundPaymentForm={
            setEmailAddressToSendRefundPaymentForm
          }
          closeIcon={closeIcon}
          calculatedTotalFoodItemPrice={calculatedTotalFoodItemPrice}
          handleCheckboxSelection={handleCheckboxSelection}
          selectedPartialRefundItems={selectedPartialRefundItems}
          alteredQuantity={alteredQuantity}
          handleQuantityChange={handleQuantityChange}
          handleAddonCheckbox={handleAddonCheckbox}
          refundProcessingType={refundProcessingType}
          WithdrawRefundRequest={WithdrawRefundRequest}
          WithdrawPartialRefundRequest={WithdrawPartialRefundRequest}
          withdrawPartialRefundOnAction={withdrawPartialRefundOnAction}
          GetAllTransaction={GetAllTransaction}
          selectedTransactionToRefundFrom={selectedTransactionToRefundFrom}
          withdrawRefundTransactionSelection={
            withdrawRefundTransactionSelection
          }
          checkForRequiredAmountToWithdraw={checkForRequiredAmountToWithdraw}
          hasRemainingAmount={hasRemainingAmount}
          selectedRestaurant={selectedRestaurant}
          bankDetailsList={bankDetailsList}
          setSelectedBank={setSelectedBank}
          selectedBank={selectedBank}
          refundProcessingTypeValidationError={
            refundProcessingTypeValidationError
          }
          emailValidationError={emailValidationError}
        />
      )}
      {loading && <LoadingView open={true} close={() => setLoading(false)} />}
    </>
  );
};

export default OrderRow;
